$(() => {
    'use strict';
    
    // Breakpoint where we destroy swiper for Testimonials swiper on mobile (case 1189)
    const swiperBreakpointTestimonials = window.matchMedia('(min-width: 667px)');
    // Keep track of swiper instances
    let myTestimonialsSwiper = void 0;

    const swiperBreakpointTestimonialsChecker = () => {
        // Cleaner condition checks
        if (swiperBreakpointTestimonials.matches) {
            // Clean up old instances and inline styles when available
            if (myTestimonialsSwiper !== undefined) {
                swiperDestroyTestimonials();
                myTestimonialsSwiper.destroy(true, true);
            }
        } else {
            // Fire small viewport version of swiper
            swiperEnableTestimonials();
        }
    };
    
    const swiperDestroyTestimonials = () => {
        // Simplified class removal with array iteration
        const elementsToClean = [
            { selector: '.swiper-testimonials', className: 'swiper-container' },
            { selector: '.sw-wrapper', className: 'swiper-wrapper' },
            { selector: '.sw-slide', className: 'swiper-slide' }
        ];
        
        elementsToClean.forEach(({ selector, className }) => {
            const $element = $(selector);
            if ($element.length && $element.hasClass(className)) {
                $element.removeClass(className);
            }
        });
    };

    const swiperInitializeTestimonials = () => {
        // Simplified class addition with array iteration
        const elementsToInitialize = [
            { selector: '.swiper-testimonials', className: 'swiper-container' },
            { selector: '.sw-wrapper', className: 'swiper-wrapper' },
            { selector: '.sw-slide', className: 'swiper-slide' }
        ];
        
        elementsToInitialize.forEach(({ selector, className }) => {
            const $element = $(selector);
            if ($element.length && !$element.hasClass(className)) {
                $element.addClass(className);
            }
        });
    };

    const swiperEnableTestimonials = () => {
        if (!$('.swiper-testimonials').length) return;
        
        swiperInitializeTestimonials();
        
        myTestimonialsSwiper = new Swiper('.swiper-testimonials', {
            loop: true,
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: true,
            a11y: true,
            keyboardControl: true,
            grabCursor: true,
            // Breakpoints
            breakpoints: {
                460: {
                    slidesPerView: 1,
                    spaceBetween: 10
                }
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    };
    
    // Keep an eye on viewport size changes
    swiperBreakpointTestimonials.addListener(swiperBreakpointTestimonialsChecker);
    // Start Testimonials Swiper
    swiperBreakpointTestimonialsChecker();
});